import React from "react";

interface ProductDescriptionSectionProps {
  product: any;
}
const ProductDescriptionSection: React.FC<ProductDescriptionSectionProps> = ({
  product,
}) => {
  return (
    <div className="flex mx-5 md:mx-0 md:mb-2 mt-2">
      <p className="text-xs md:text-base font-normal text-graySlate">
        {product.description}
      </p>
    </div>
  );
};

export default ProductDescriptionSection;
